import { render, staticRenderFns } from "./DispatchBatches.vue?vue&type=template&id=4f2b9e11&"
import script from "./DispatchBatches.vue?vue&type=script&lang=js&"
export * from "./DispatchBatches.vue?vue&type=script&lang=js&"
import style0 from "./DispatchBatches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports